<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-header bg-transparent pb-5">
          <div class="text-muted text-center mt-2 mb-3">
            <small>Registrarse con:</small>
          </div>
          <div class="btn-wrapper text-center">
            <button class="btn btn-neutral btn-icon" @click="google_login">
                <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                <span class="btn-inner--text">Google</span>
            </button>
          </div>
        </div>
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <small>O registrarse manualmente:</small>
          </div>
          <form role="form" @submit.prevent="register">
            <base-input
              class="input-group-alternative mb-3"
              placeholder="Nombre"
              addon-left-icon="ni ni-hat-3"
              v-model="name"
            >
            </base-input>

            <base-input
              class="input-group-alternative mb-3"
              placeholder="Correo electrónico"
              type="email"
              addon-left-icon="ni ni-email-83"
              v-model="email"
            >
            </base-input>

            <base-input
              class="input-group-alternative"
              placeholder="Contraseña"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="password"
            >
            </base-input>

            <div class="text-muted font-italic">
              <small
                >password strength:
                <span class="text-success font-weight-700">strong</span></small
              >
            </div>

            <div class="row my-4">
              <div class="col-12">
                <base-checkbox id="politica" class="custom-control-alternative" v-model="checked">
                  <span class="text-muted"
                    >Acepto los términos de la
                    <router-link to="/politica_privacidad" class="mb-3">
                        Política de privacidad
                    </router-link></span
                  >
                </base-checkbox>
                <small v-if="alert"  style="color:red;">Debe aceptar las políticas de privacidad</small>
              </div>
            </div>
            <div class="text-center">
              <button type="primary" class="my-4 btn btn-primary"
                >Crear cuenta</button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <a href="#" class="text-light">
            <small>¿Has olvidado la contraseña?</small>
          </a>
        </div>
        <div class="col-6 text-right">
          <router-link to="/login" class="text-light">
            <small>Iniciar sesión</small>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebaseDb, { auth } from '../firebaseDb';
import { db } from "../firebaseDb";
export default {
  name: "register",
  data() {
    return {
        name: "",
        email: "",
        password: "",
        checked: false,
        alert: false
    };
  },
  methods: {
    register() {
      if (this.checked) {
        var self = this
        auth
          .createUserWithEmailAndPassword(this.email, this.password)
          .then((user) => auth.currentUser.sendEmailVerification().then(function() {
          // Email sent.
          console.log('Enviado mail de verificación')
          db.collection("users")
            .doc(auth.currentUser.uid)
            .set({
              firstName: self.name,
              user_email: self.email,
              city: "",
              country: "",
              lastName: "",
              rol: "user",
              user_avatar: "img/theme/team-4-800x800.jpg",
              user_name: "",
              zipCode: "00000"
            })
            .catch((error) => {
              console.log(error);
            });

        }).catch(function(error) {
          // An error happened.
          console.log(error)
        }))
          .catch(function (error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // ...
        });
      } else {
        console.log(this.checked)
        this.alert = true
      }
      
      
    },
    async google_login(){
        const asd = await firebaseDb.login();
        db.collection("users").doc(auth.currentUser.uid).get()
          .then((snapshot) => {
            if(!snapshot.exists){
              db.collection("users")
            .doc(auth.currentUser.uid)
            .set({
              firstName: auth.currentUser.displayName,
              user_email: auth.currentUser.email,
              city: "",
              country: "",
              lastName: "",
              rol: "user",
              user_avatar: "img/theme/team-4-800x800.jpg",
              user_name: "",
              zipCode: "00000"
            })
            .catch((error) => {
              console.log(error);
            });
            }
          })
        this.$router.replace('dashboard')
    }
  },
};
</script>
<style>
</style>
